import currentConferencePhase from '../experience/conference'

const ancestryId = '0000017c-c7b2-d348-af7c-c7f634960000'

const opens = currentConferencePhase.starts

// NOTE: generally this happens at the end of 3rd quarter.
const closes = '2027-08-13T18:00:00-06:00'

const promotionsStarts = '2027-03-04T05:00:00-07:00'
const promotionsEnds = '2027-04-01T07:00:00-07:00'
const promotionsEditDeadline = '2027-02-28T07:00:00.000Z'

const promotionsStartsTimestamp = new Date(promotionsStarts).toISOString()
const promotionsEndsTimestamp = new Date(promotionsEnds).toISOString()
const promotionsEditDeadlineTimestamp = new Date(promotionsEditDeadline).toISOString()

const expoHallConfig = {
  opens,
  closes,
  locales: ['en', 'de', 'fr', 'it', 'es', 'pt'],
  promotions: {
    editDeadline: promotionsEditDeadline,
    editDeadlineTimestamp: promotionsEditDeadlineTimestamp,
    starts: promotionsStarts,
    startsTimestamp: promotionsStartsTimestamp,
    ends: promotionsEnds,
    endsTimestamp: promotionsEndsTimestamp,
    path: '/expohall',
  },
  hrlEditDeadline: promotionsEditDeadline,
  searchTopics: [
    'Charts',
    'DNA',
    'Professionals',
    'Storytelling',
    'Travel',
    'Records',
    'Research',
    'Preservation',
    'Family History',
    'Technology',
    'Connection',
    'Tree Chart',
    'Search Family',
    'Society',
    'Association',
    'Library',
  ],
  sponsors: {
    withDisclaimers: [ancestryId],
    platinum: ['ancestry', 'familysearch', 'myheritage', 'storied'],
  },
}

export default expoHallConfig
